// extracted by mini-css-extract-plugin
export var badge = "reviewBadges-module--badge--7e8b1";
export var container = "reviewBadges-module--container--581da";